/**
 * Pending payment reason → UI chip (spec 20260916). The server decides which
 * list a deal is in and why; this only renders the reason it sends.
 */
import { formatDayDate } from './dayDate.js';

const NO_PAYOUT_DETAILS = { label: 'No payment details', badgeClass: 'badge-warning' };

/** Chip for one pending row; null when the row carries no reason. */
export function pendingReasonChip(row) {
    const reason = row?.pendingReason;
    if (!reason) return null;
    if (reason === 'no_payout_details') return NO_PAYOUT_DETAILS;
    if (reason === 'awaiting_box') {
        const until = formatDayDate(row.boxWaitUntil);
        return { label: until ? `Waiting for box until ${until}` : 'Waiting for box', badgeClass: 'badge-info' };
    }
    // A reason this build does not know yet still shows, so a held deal is
    // never rendered as if it had no reason.
    return { label: reason, badgeClass: 'badge-neutral' };
}
